// Logotipo oficial da Alpha Metais (enviado pelo cliente)
const LOGO_URL = "/logo.png";

export default function Logo({ compact = false }) {
  if (LOGO_URL) {
    return (
      <img
        src={LOGO_URL}
        alt="Alpha Metais"
        className={compact ? "h-11 w-auto object-contain rounded-sm" : "h-14 w-auto object-contain rounded-sm"}
        data-testid="logo-image"
      />
    );
  }
  return (
    <div className="flex items-center gap-2 select-none">
      <div className="relative w-9 h-9 grid place-content-center border-2 border-orange-500 rounded-sm bg-zinc-900">
        <span className="display font-extrabold text-orange-500 text-lg leading-none">A</span>
        <span className="absolute -bottom-px -right-px w-2 h-2 bg-orange-500" />
      </div>
      {!compact && (
        <div className="leading-none">
          <div className="display text-xl font-extrabold tracking-[0.12em] text-zinc-100">
            ALPHA <span className="text-orange-500">METAIS</span>
          </div>
          <div className="text-[9px] mono uppercase tracking-[0.3em] text-zinc-500 mt-1">
            usinagem cnc · corte · solda · fabricação
          </div>
        </div>
      )}
    </div>
  );
}
